import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { ShipmentModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class ShipmentsV2Repository {
  constructor(private apiService: ApiService) {}

  public get(shipmentId: number): Observable<ShipmentModel> {
    return this.apiService.get<ShipmentModel>(`${environment.url.prefixCustoms}v2/shipments/${shipmentId}`);
  }

  public create(esId: number, shipment: Partial<ShipmentModel>, isShowLoader?: boolean): Observable<ShipmentModel> {
    return this.apiService.post<ShipmentModel>(`${environment.url.prefixCustoms}v2/entry-summaries/${esId}/shipments`, shipment, null, {
      isShowLoader,
    });
  }

  public update(shipmentId: number, shipment: Partial<ShipmentModel>): Observable<ShipmentModel> {
    return this.apiService.put<ShipmentModel>(`${environment.url.prefixCustoms}v2/shipments/${shipmentId}`, shipment);
  }

  public delete(shipmentId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/shipments/${shipmentId}`);
  }

  public fillEntrySummaryByIsfShipment(entrySummaryId: number, isfShipmentId: number): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/shipments/${isfShipmentId}`, { entrySummaryId });
  }
}
